import { Button } from "react-bootstrap";
import useGetTableData from "../../../../hook/useGetTableData";
import TableTemplate from "../../../component/table-pagination";
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "../../../utils/Constant";
import { SIGNATURE_FORM_COLUMNS } from "../../constants/columns";
import { getSignatureForm } from "../../services";

const SignatureForm = () => {
	const { query, setQuery, data } = useGetTableData({
		fetchApi: getSignatureForm,
		initialQuery: {
			pageIndex: DEFAULT_PAGE_INDEX,
			pageSize: DEFAULT_PAGE_SIZE,
		},
	});

	return (
		<div>
			<div className="d-flex justify-content-between align-items-center my-3">
				<h3 className="text-info mb-0 fs-5">Danh sách bác sĩ ký phiếu</h3>
				<Button className="btn-fill spaces px-16 w-60">Ký</Button>
			</div>
			<TableTemplate
				data={data}
				columns={SIGNATURE_FORM_COLUMNS}
				paging={{
					totalPages: data?.admissions?.totalPages ?? 0,
					totalElements: data?.admissions?.totalElements ?? 0,
					numberOfElements: data?.admissions?.numberOfElements ?? 0,
				}}
				selectable
				tableClassname="h-250"
				onPagingChange={(page, size) => {
					setQuery({
						...query,
						pageIndex: page,
						pageSize: size,
					});
				}}
			/>
		</div>
	);
};

export default SignatureForm;
